/* eslint-disable eqeqeq */
import React, { useState, useContext, useEffect, useDeepEffect } from "react";
import tenantConfig from "../../../mocks/tenantOne.json";
import permissions from "../../../mocks/menuPermissions.json";
import {
  Button,
  Row,
  Col,
  Image,
  Form,
  InputGroup,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import * as fileSaver from "file-saver";
import { camelCase } from "lodash";
import {
  SliderPanel,
  LoaderWrapper,
  CsplTable as Table,
  FormControlSearch,
  ManagePayrollLayout,
  FieldInputDecimal,
} from "../../../components";
import {
  MANAGE_PAYROLL_ROUTES,
  ROUTES,
  FLOW_TYPES,
  formFields,
  getFlowBasedFormValues,
  managePayrollFormNames,
  getAdvancedPathWithParam,
  ssnMasking,
} from "../../../utils";
import { useRouterParams, useRequest } from "../../../abstracts";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import {
  faPencilAlt,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import {
  getPayrollMetaDataDetails,
  getCreatePayrollInformationByFileId,
  downloadCreatePayrolldetail,
  UpdatePayrollEmployee,
  submitCreatePayroll,
} from "../../../services";
import { isEmpty, isNull } from "lodash";
import ExcelImage from "../../../styles/exportimg.PNG";
import { get } from "lodash";
import { managePayrollStore, setManagePlanToastInfo } from "../../../contexts";
import {
  SearchDropdownWithAPI,
  FieldInput,
  FieldInputDollar,
} from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, FieldArray, Formik } from "formik";
import AddToolTip from "../../../components/AddToolTip";
import EmployeeInformationWizard from "./EmployeeInformationWizard";
import SearchBar from "../../Mapper/LoadDefHomeContainer/SearchBar";
import authService from "../../../components/api-authorization/AuthorizeService";

const CreatePayrollListingContainer = (props) => {
  //const [employeeData, setEmployeeData] = useState([]);
  const history = useHistory();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [Edata, setEdata] = useState({});
  const [sourceData, setSourceData] = useState({});
  const [isModalEmployeeWizardOpen, setModalEmployeeWizardOpen] = useState(
    false
  );
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [searchEmployee, setSearchEmployee] = useState("");
  const { payrollId, flow } = useRouterParams();
  const [sidePanelData, setSidePanelData] = useState({});
  const formName = managePayrollFormNames.CREATE_PAYROLL_LISTING;
  const fields = formFields[formName];
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const { response: data, loading: isLoading } = useRequest({
    method: getPayrollMetaDataDetails,
    payload: payrollId,
    defaultResponse: {},
  });
  const [employeeData, setEmployeeData] = useState();
  useEffect(() => {
    getCreatePayrollInformationByFileId(payrollId).then((response) => {
      setEmployeeData(response);
    });
  }, []);

  var searchResult = searchEmployee
    ? employeeData.filter(
        (_) =>
          _.uniquePersonalIdentification.includes(searchEmployee) ||
          _.firstName.toLowerCase().includes(searchEmployee.toLowerCase()) ||
          _.lastName.toLowerCase().includes(searchEmployee.toLowerCase())
      )
    : employeeData;
  var eligibleData = (employeeData || []).filter(
    (_) => _.isPayrollDetail === true
  );
  var eligibleCount = eligibleData.length;

  var ineligibleCount = (employeeData || []).filter(
    (_) => _.isPayrollDetail === false
  ).length;

  const exportReportFile = () => {
    downloadCreatePayrolldetail(eligibleData, data.companyId, payrollId)
      .then((response) => {
        var blob = new Blob([response], {
          type: "text/csv",
        });
        fileSaver.saveAs(blob, "CreatePayrolldetail.csv");
      })
      .catch((error) => {});
  };
  const UpdatepayrollEmployees = (values, { setSubmitting }) => {
    setSubmitting(true);
    UpdatePayrollEmployee(employeeData.filter((_) => _.isPayrollDetail))
      .then((response) => {
        history.push(
          getAdvancedPathWithParam({
            path: `${ROUTES.PAYROLL}`,
            pathParam: [],
          })
        );
      })
      .catch((error) => {});
  };
  const submitPayroll = (values, { setSubmitting }) => {
    setSubmitting(true);
    if (isEmpty(employeeData.filter((_) => _.isPayrollDetail))) {
      setIsPopupOpen(true);
    } else {
      submitCreatePayroll(
        employeeData.filter((_) => _.isPayrollDetail),
        data.companyId,
        payrollId
      )
        .then((response) => {
          history.push(
            getAdvancedPathWithParam({
              path: `${ROUTES.PAYROLL}`,
              pathParam: [],
            })
          );
        })
        .catch((error) => {});
    }
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };
  const calculateTotalContribution = (data) => {
    let sum = 0;
    data.payrollPlans.forEach((_) => {
      _.sources.forEach((_) => {
        sum += _.contributionAmount ?? 0;
      });
    });
    return sum;
  };
  useEffect(() => {
    if (Edata.payrollPlans && Edata.payrollPlans.length > 0)
      setSourceData(Edata.payrollPlans[0]);
  }, [Edata.payrollPlans]);
  const onViewEmployeeWizard = (data) => {
    setModalEmployeeWizardOpen(true);
    setSidePanelData(data);
  };
  const onEditButtonClick = (data) => {
    setSliderOpen(true);
    setEdata(data);
  };
  const onSave = (values) => {
    let val = employeeData.map((item) => {
      if (item.employeeId === values.employeeId) {
        return { ...values };
      }
      return item;
    });
    setEmployeeData(val);
    setSliderOpen(false);
  };
  const displaySource = (d) => {
    setSourceData(d);
  };

  const buttons = [
    // {
    //   link: ROUTES.PAYROLL,
    //   label: "Cancel",
    //   variant: "secondary",
    //   type: "button",
    //   flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    //   onClick: () => setModalEmployeeWizardOpen(false),
    // },
    // {
    //   label: "Save",
    //   variant: "primary",
    //   type: "submit",
    //   flow: [FLOW_TYPES.ADD],
    //   link: ROUTES.PAYROLL,
    // },
    {
      label: "Close",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      //icon: faTimes,
      onClick: () => setModalEmployeeWizardOpen(false),
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faPencilAlt,
    //   onClick: () => setNewFlow(FLOW_TYPES.SAVE),
    // },
    // {
    //   label: "Save",
    //   variant: "primary",
    //   type: "submit",
    //   flow: [FLOW_TYPES.SAVE],
    //   link: ROUTES.PAYROLL,
    // },
  ];
  const initialValues = {
    payrollDetails: undefined,
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  return (
    <LoaderWrapper isLoading={isLoading}>
      <div
        className="create-payroll-container w-100"
        style={{ paddingLeft: "50px" }}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={submitPayroll}
        >
          {({
            handleChange,
            setFieldValue,
            setFieldTouched,
            handleSubmit,
            setSubmitting,
            isSubmitting,
            submitForm,
            isValid,
            dirty,
            errors,
            values,
            ...rest
          }) => {
            const buttons1 = [
              {
                label: "Cancel",
                variant: "secondary",
                type: "button",
                onClick: () => {
                  history.push(
                    getAdvancedPathWithParam({
                      path: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
                    })
                  );
                },
                // flow: [FLOW_TYPES.EDIT],
              },
              {
                label: "Continue Later",
                variant: "secondary",
                type: "submit",
                onClick: () => {
                  UpdatepayrollEmployees(values, { setSubmitting });
                },
                // flow: [FLOW_TYPES.EDIT],
              },
              tenantConfig["payrollSubMenu"]?.includes(
                "createPayrollListing"
              ) &&
              permissions[roleName]["payrollSubMenu"][
                camelCase("createPayrollListing")
              ].includes("C")
                ? {
                    label: "Submit",
                    variant: "primary",
                    type: "submit",
                    onClick: () => {
                      submitPayroll(values, { setSubmitting });
                    },
                    // flow: [FLOW_TYPES.EDIT],
                  }
                : {
                    label: "Submit",
                    variant: "primary",
                    disabled: true,
                  },
            ];
            return (
              <ManagePayrollLayout
                buttons={buttons1}
                layoutHeader="Payroll & Census"
              >
                <div className="d-flex justify-content-between align-baseline">
                  {/* <div className="plan-heading font-weight-500">
                    Payroll & Census
                  </div> */}
                  <div className="mt-10">
                    {/* <Link to={MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING}>
              Cancel
            </Link> */}
                    {/* <Link to={ROUTES.PAYROLL}> */}

                    {/* <Button
              variant="secondary"
              className="mr-4 ml-4"
              onClick={() => {
                UpdatepayrollEmployees();
              }}
            > */}
                    {/* Continue later
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                submitPayroll();
              }}
            >
              Submit
            </Button> */}
                  </div>
                </div>
                {/* <div className="border-top" /> */}
                <div className="mt-20">
                  {/* <p className="payroll-sub-heading">Create Payroll</p> */}
                  <Row className="header-text">
                    <Col sm="4">
                      <p className="payroll-sub-heading">Create Payroll</p>
                      <h1
                        style={{
                          fontSize: "20px",
                        }}
                        className="text-black"
                      >
                        {data.companyName}
                      </h1>
                      {/* { <p className="grey-title">Plan Name</p> } */}
                      {/* <p className="company-title font-weight-500 text-black mbb-5"> */}
                      {/* {data.planName} */}
                      {/* </p> */}
                      {/* <p className="plan-id"> */}
                      {/* <span>Plan ID :</span> {data.rkPlanNumber} */}
                      {/* </p> */}
                    </Col>
                    <Col sm="2">
                      <h4 className="company-title font-weight-500">
                        {data.payrollFrequencyName}
                      </h4>
                      <p className="grey-title">Pay date</p>
                      <p>{data.payDate}</p>
                    </Col>
                    <Col sm="3" style={{}}>
                      <h4 className="company-title font-weight-500">
                        {data.fileName}
                      </h4>

                      <AddToolTip
                        className="short-desc"
                        name={data.description}
                        placement="bottom"
                      >
                        {(data.description || "").slice(0, 150)}
                      </AddToolTip>
                    </Col>

                    <Col sm="3">
                      <p className="total-title">Total employees</p>

                      <h4>
                        {eligibleCount}/
                        {employeeData != null ? employeeData.length : 0}
                      </h4>
                    </Col>
                  </Row>
                </div>
                <div className="line-separator-var" />

                <Row>
                  <Col>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "30px",
                      }}
                    >
                      <div
                        className="search-bar"
                        style={{ width: "30%", paddingLeft: "0px" }}
                      >
                        <Form>
                          {/* <InputGroup>
                                      <InputGroup.Prepend>
                                        <InputGroup.Text className="plan-search-button">
                                          <Image
                                            src="/assets/icons/svg/search.svg"
                                            width="14px"
                                          />
                                        </InputGroup.Text>
                                      </InputGroup.Prepend> */}
                          <div className="flex-search">
                            <InputGroup>
                              <InputGroup.Prepend>
                                <div className="searchIconPostion">
                                  <i
                                    class="fal fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </InputGroup.Prepend>

                              <SearchBar
                                size="md"
                                type="search"
                                placeholder="Search SSN or employee name"
                                className="PadLeftSearch"
                                onChange={(e) =>
                                  setSearchEmployee(e.target.value)
                                }
                              />
                            </InputGroup>
                          </div>

                          {/* </SearchBar> */}
                        </Form>
                      </div>
                    </div>
                  </Col>
                </Row>

                <div
                  className="employee-and-payroll-details d-flex-row"
                  style={{ height: "60vh" }}
                >
                  <div
                    className="w-368 marg-right-35 mt-2"
                    style={{
                      width: "25%",
                      height: "270px",
                      borderRadius: "5px 0px 5px 0px",
                      backgroundColor: "none !important",
                    }}
                  >
                    <div
                      className="employee-details-title d-flex-row"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignContent: "center",
                        backgroundColor: "#f6f6f6",
                      }}
                    >
                      <p className="font-weight-500 text-black ft-14 mt-2 ml-2">
                        Employee Details
                      </p>
                      <p
                        className="grey-title ft-12"
                        style={{
                          marginTop: "0.6rem",
                          marginLeft: "105px",
                          marginRight: "10px",
                        }}
                      >
                        {ineligibleCount} Employees
                      </p>
                    </div>
                    <div
                      className="employee-details-table "
                      style={{ width: "100%", backgroundColor: "#f6f6f6" }}
                    >
                      <div
                        classNname="employee-details-header d-flex-row justify-content-space-between "
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <p className="font-weight-500 text-black ft-12 marg-left-6">
                          SSN and Name
                        </p>
                        {tenantConfig["payrollSubMenu"]?.includes(
                          "createPayrollListing"
                        ) &&
                          permissions[roleName]["payrollSubMenu"][
                            camelCase("createPayrollListing")
                          ].includes("C") && (
                            <div
                              className="link primary-small pointer ft-14 font-weight-500 marg-right-42"
                              onClick={() => {
                                setEmployeeData(
                                  employeeData.map((d, i) =>
                                    d.isPayrollDetail === false
                                      ? { ...d, isPayrollDetail: true }
                                      : d
                                  )
                                );
                                setFieldValue(
                                  fields.payrollDetails,
                                  employeeData.map((d, i) =>
                                    d.isPayrollDetail === false
                                      ? { ...d, isPayrollDetail: true }
                                      : d
                                  )
                                );
                              }}
                            >
                              Add all
                            </div>
                          )}
                      </div>
                      {/* {searchResult.length} */}
                      <div className="line-separator marg-0" />
                      <div className="employee-list" style={{ width: "100%" }}>
                        {!isEmpty(searchResult) ? (
                          ineligibleCount != 0 ? (
                            searchResult.map((data, index) =>
                              data.isPayrollDetail === false ? (
                                <div
                                  className="employee-tile marg-top-20"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    className="d-flex-col"
                                    style={{ paddingLeft: "6px" }}
                                  >
                                    <p className="tile-ssn ft-14">
                                      {ssnMasking(
                                        data.uniquePersonalIdentification
                                      )}
                                    </p>
                                    <p className="tile-name ft-12">
                                      {data.firstName} {data.lastName}
                                    </p>
                                  </div>
                                  {tenantConfig["payrollSubMenu"]?.includes(
                                    "createPayrollListing"
                                  ) &&
                                    permissions[roleName]["payrollSubMenu"][
                                      camelCase("createPayrollListing")
                                    ].includes("C") && (
                                      <AddToolTip
                                        placement="bottom"
                                        name="This will move the employee to the payroll details"
                                      >
                                        <div className="pointer">
                                          {/* <div className="Arrows" style={{paddingTop:'5px'}} >
                                  <i className="fa fa-long-arrow-right" style={{color:'rgba(47, 128, 237, 1)',fontSize:'20px',fontWeight:'500', }} aria-hidden="true"></i>
                                </div> */}
                                          <i
                                            className="fa fa-long-arrow-right primary-color"
                                            style={{
                                              fontSize: "20px",
                                              fontWeight: "500",
                                              marginRight: "20px",
                                            }}
                                            aria-hidden="true"
                                            onClick={
                                              () => {
                                                setEmployeeData(
                                                  employeeData.map((d, i) =>
                                                    d.uniquePersonalIdentification ===
                                                    data.uniquePersonalIdentification
                                                      ? {
                                                          ...d,
                                                          isPayrollDetail: true,
                                                        }
                                                      : d
                                                  )
                                                );
                                                setFieldValue(
                                                  fields.payrollDetails,
                                                  employeeData.map((d, i) =>
                                                    d.uniquePersonalIdentification ===
                                                    data.uniquePersonalIdentification
                                                      ? {
                                                          ...d,
                                                          isPayrollDetail: true,
                                                        }
                                                      : d
                                                  )
                                                );
                                              }
                                              // showTile()//,//(plan) => !mappings.map((item) => item.planId).includes(plan.id)
                                              // setEligibility(
                                              //   employeeData.filter(
                                              //     (emp) => emp.isPayrollDetail==0
                                              //   ).length,
                                              // )
                                            }
                                          />
                                        </div>
                                      </AddToolTip>
                                    )}
                                </div>
                              ) : null
                            )
                          ) : (
                            <p
                              style={{ fontSize: "15px", textAlign: "center" }}
                            >
                              All Employees are added to payroll{" "}
                            </p>
                          )
                        ) : (
                          <p style={{ fontSize: "20px", textAlign: "center" }}>
                            No Records Found
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="payroll-details" style={{ width: "75%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        className="font-weight-500 text-black ft-14 mt-3"
                        style={{ width: "200px" }}
                      >
                        Payroll Details
                      </p>
                      <p
                        className="grey-title ft-12 mt-3"
                        style={{ paddingLeft: "320px", width: "500px" }}
                      >
                        {ineligibleCount === 0 ? "All" : eligibleCount}{" "}
                        Employees added for payroll
                      </p>
                      <div
                        className="ft-12 grey-text font-weight-500 marg-right-5"
                        style={{
                          marginBottom: "10px",
                        }}
                      >
                        <Button
                          className="export-button"
                          title="Export Excel"
                          variant="secondary"
                          style={{ border: "none" }}
                          onClick={() => {
                            exportReportFile();
                          }}
                        >
                          <Image src={ExcelImage} width="20px" />
                          Export
                        </Button>
                      </div>
                    </div>
                    <div
                      style={{
                        height: "auto",
                        maxHeight: "390px",
                        //border: "1px solid #E0E0E0",
                      }}
                    >
                      <Table>
                        <Table.Thead>
                          <Table.Tr className="ft-12 font-weight-500">
                            <Table.Th className="column-remove">
                              Remove
                            </Table.Th>
                            <Table.Th className="column-ssnAndname">
                              SSN & Employee name
                            </Table.Th>
                            <Table.Th className="column-ytd">Hours</Table.Th>
                            <Table.Th className="column-compensation">
                              Plan Compensation
                            </Table.Th>
                            <Table.Th className="column-compensation">
                              Gross Compensation
                            </Table.Th>
                            <Table.Th className="column-totalContribution">
                              Total Contribution
                            </Table.Th>
                            <Table.Th className="column-Action">
                              Action
                            </Table.Th>
                          </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                          {!isEmpty(employeeData) &&
                            employeeData.map((data, index) => (
                              <div>
                                {data.isPayrollDetail === true ? (
                                  <Table.Tr>
                                    <Table.Td className="column-remove">
                                      {tenantConfig["payrollSubMenu"]?.includes(
                                        "createPayrollListing"
                                      ) &&
                                        permissions[roleName]["payrollSubMenu"][
                                          camelCase("createPayrollListing")
                                        ].includes("C") && (
                                          <AddToolTip
                                            placement="bottom"
                                            name="This will move the employee to the employee details"
                                          >
                                            <div className="pointer">
                                              <div className="Arrows">
                                                <i
                                                  className="fa fa-long-arrow-left primary-color"
                                                  style={{
                                                    fontSize: "20px",
                                                    fontWeight: "500",
                                                  }}
                                                  aria-hidden="true"
                                                  onClick={() => {
                                                    setEmployeeData(
                                                      employeeData.map((d, i) =>
                                                        i === index
                                                          ? {
                                                              ...d,
                                                              isPayrollDetail: false,
                                                            }
                                                          : d
                                                      )
                                                    );
                                                    setFieldValue(
                                                      fields.payrollDetails,
                                                      employeeData.map((d, i) =>
                                                        i === index
                                                          ? {
                                                              ...d,
                                                              isPayrollDetail: false,
                                                            }
                                                          : d
                                                      )
                                                    );
                                                    // newData
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </AddToolTip>
                                        )}
                                    </Table.Td>

                                    <Table.Td className="column-ssnAndname">
                                      <div className="d-flex-col marg-left-12">
                                        <p className="ft-12 font-weight-400 marg-bot-0">
                                          {ssnMasking(
                                            data.uniquePersonalIdentification
                                          )}
                                        </p>
                                        <p
                                          className="ft-14 font-weight-500 marg-top-5 primary-color "
                                          style={{
                                            width: "100px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            onViewEmployeeWizard(
                                              data.employeeId
                                            );
                                          }}
                                        >
                                          {data.firstName} {data.lastName}
                                        </p>
                                      </div>
                                    </Table.Td>
                                    <Table.Td className="column-ytd">
                                      {isNull(data.hours) ? "-" : data.hours}
                                    </Table.Td>
                                    <Table.Td className="column-compensation">
                                      {isNull(data.planCompensation)
                                        ? "-"
                                        : data.planCompensation}
                                    </Table.Td>
                                    <Table.Td className="column-compensation">
                                      {isNull(data.grossCompensation)
                                        ? "-"
                                        : data.grossCompensation}
                                    </Table.Td>
                                    <Table.Td className="column-totalContribution">
                                      {calculateTotalContribution(data)}
                                    </Table.Td>
                                    <Table.Td className="column-Action">
                                      <p>
                                        {tenantConfig[
                                          "payrollSubMenu"
                                        ]?.includes("createPayrollListing") &&
                                          permissions[roleName][
                                            "payrollSubMenu"
                                          ][
                                            camelCase("createPayrollListing")
                                          ].includes("C") && (
                                            <div
                                              className="link primary-small pointer"
                                              onClick={() => {
                                                onEditButtonClick(data);
                                                // setFieldValue(fields.Compensation, value);
                                              }}
                                            >
                                              Edit
                                            </div>
                                          )}
                                      </p>
                                    </Table.Td>
                                  </Table.Tr>
                                ) : null}
                              </div>
                            ))}
                          {isEmpty(employeeData) && (
                            <p
                              style={{ fontSize: "20px", textAlign: "center" }}
                            >
                              No Records Found
                            </p>
                          )}
                        </Table.Tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </ManagePayrollLayout>
            );
          }}
        </Formik>

        {/* {data.companyId && (
          <EmployeeListing
            payrollId={payrollId}
            // companyId={data.companyId ? data.companyId : null}
            onViewButtonClick={onViewButtonClick}
            onViewEmployeeWizard={onViewEmployeeWizard}
          />
        )} */}
        <SliderPanel isOpen={isSliderOpen} size="40" showCancel={false}>
          <div>
            <Formik initialValues={Edata} enableReinitialize onSubmit={onSave}>
              {({
                handleChange,
                setFieldValue,
                handleSubmit,
                values,
                ...rest
              }) => {
                return (
                  <>
                    <div className="d-flex justify-content-between align-baseline">
                      <div>
                        <p>Payroll Contributions</p>
                      </div>
                      <div>
                        <Button
                          variant="secondary"
                          onClick={() => setSliderOpen(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          className="ml-4"
                          onClick={() => {
                            onSave(values);
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                    <div className="bb-1" />
                    <div
                      className="nameAndSSn"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "30px",
                      }}
                    >
                      <div
                        className="ssn-sliderpanel"
                        style={{ fontSize: "12px", fontWeight: "400" }}
                      >
                        {Edata.ssn}
                      </div>
                      <div
                        className="name primary-color"
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          onViewEmployeeWizard(Edata.employeeId);
                        }}
                      >
                        <p>{ssnMasking(Edata.uniquePersonalIdentification)}</p>
                        {Edata.firstName} {Edata.lastName}
                      </div>
                    </div>
                    <div
                      className="field-title"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        marginTop: "18px",
                        marginBottom: "10px",
                      }}
                    >
                      Pay period hours and compensation
                    </div>

                    <Field
                      style={{
                        width: "91px",
                        height: "36px",
                        borderRadius: "5px",
                        border: "1px solid #BDBDBD",
                      }}
                      size="sm"
                      name={fields.hours}
                      label={"Hours"}
                      placeholder="Hours"
                      autoComplete="off"
                      component={FieldInputDecimal}
                      max={9999}
                      onChange={handleChange}
                    />
                    <Field
                      style={{
                        width: "150px",
                        height: "36px",
                        marginLeft: "20px",
                        borderRadius: "5px",
                        border: "1px solid #BDBDBD",
                      }}
                      name={fields.planCompensation}
                      label="Plan Compensation"
                      autoComplete="off"
                      onChange={handleChange}
                      component={FieldInputDollar}
                      max={9999999}
                    />
                    <Field
                      style={{
                        width: "150px",
                        height: "36px",
                        marginLeft: "20px",
                        borderRadius: "5px",
                        border: "1px solid #BDBDBD",
                      }}
                      name={fields.grossCompensation}
                      label="Gross Compensation"
                      autoComplete="off"
                      onChange={handleChange}
                      component={FieldInputDollar}
                      max={9999999}
                    />
                    <Field
                      style={{
                        width: "150px",
                        height: "36px",
                        marginLeft: "20px",
                        borderRadius: "5px",
                        border: "1px solid #BDBDBD",
                      }}
                      name={fields.annualSalary}
                      label="Annual Salary"
                      autoComplete="off"
                      onChange={handleChange}
                      component={FieldInputDollar}
                    />

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "40px",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        {!isEmpty(Edata.payrollPlans) &&
                          Edata.payrollPlans.map((d, i) => (
                            // <div>{[d.sources]}</div>
                            <div
                              style={{
                                width: "240px",
                                marginTop: "15px",
                                marginLeft: "20px",
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#4F4F4F",
                              }}
                            >
                              <div
                                className="link primary-small pointer"
                                onClick={() => {
                                  displaySource(d);
                                }}
                              >
                                {d.name.length > 25 ? (
                                  <AddToolTip
                                    //className="link-text"
                                    name={d.name}
                                    //placement="bottom"
                                  >
                                    {(d.name || "").slice(0, 25)}...
                                  </AddToolTip>
                                ) : (
                                  <div>{d.name}</div>
                                )}
                              </div>{" "}
                            </div>
                          ))}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          border: "1px solid #D1D1D1",
                          width: "321px",
                          paddingBottom: "20px",
                        }}
                      >
                        <FieldArray name={"payrollPlans"}>
                          {() => (
                            <>
                              {!isEmpty(values.payrollPlans) &&
                                values.payrollPlans.map(
                                  (d, i) =>
                                    !isEmpty(d.sources) &&
                                    d.sources.map((data, index) => (
                                      <div
                                        style={{
                                          marginLeft: "20px",

                                          fontSize: "12px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {d.id == sourceData.id ? (
                                          <Field
                                            //name={fields.camelCase(data.sourceName)}
                                            label={data.sourceName}
                                            placeholder={
                                              data.contributionAmount != null
                                                ? data.contributionAmount
                                                : 0
                                            }
                                            autoComplete="off"
                                            name={`payrollPlans[${i}].sources[${index}].contributionAmount`}
                                            onChange={handleChange}
                                            component={FieldInputDollar}
                                            max={9999999}
                                          />
                                        ) : null}
                                      </div>
                                    ))
                                )}
                            </>
                          )}
                        </FieldArray>
                      </div>
                    </div>
                  </>
                );
              }}
            </Formik>
          </div>
        </SliderPanel>
        <SliderPanel
          isOpen={isModalEmployeeWizardOpen}
          size="80"
          showCancel={false}
        >
          <div className="scroll-body">
            <ManagePayrollLayout buttons={buttons} pageFlow={"edit"}>
              <EmployeeInformationWizard
                data={sidePanelData}
                isSave={isSave}
                isEdit={isEdit}
              />
            </ManagePayrollLayout>
          </div>
        </SliderPanel>

        <Modal show={isPopupOpen} onHide={handleClose}>
          <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
            <div className="text-right">
              <FontAwesomeIcon
                icon={faTimes}
                color="#000"
                onClick={handleClose}
              />
            </div>
            <div className="d-flex">
              <div className="pd-15">
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  color="#f94f50"
                  size="3x"
                />
              </div>
              <div className="remove-text">
                <h4>Warning</h4>
                <p>Add Employees to Payroll to Proceed further</p>
                <br />
                <Button className="remove-btn mr-4" onClick={handleClose}>
                  Ok
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </LoaderWrapper>
  );
};

export default CreatePayrollListingContainer;
